<script setup lang="ts">
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import type { PaletteColorProp, IconSize } from '#imports';

interface IProps {
    numberOfStars?: number | string;
    percent?: number;
    color?: PaletteColorProp | string;
    size?: IconSize;
}

const {
    percent = 50,
    size = 'x-small',
    numberOfStars = 5,
    color = 'var(--yellow-400)',
} = defineProps<IProps>();
const starPercents = computed(() =>
    [...Array(numberOfStars).keys()]
        .map(index =>
            Math.max(
                0,
                Math.min(100, percent * Number(numberOfStars) - index * 100)
            )
        )
        .filter(Boolean)
);
</script>

<template>
    <div class="rating-container">
        <mr-icon
            v-for="i in starPercents.length"
            :key="i - 1"
            class="star"
            :icon="faStar"
            :color
            :size
        />
        <mr-typography weight="500" color="var(--cool-gray-800)">
            {{ starPercents.length }} ستاره
        </mr-typography>
    </div>
</template>

<style scoped>
.rating-container {
    display: flex;
    align-items: start;
    gap: 2px;
}
</style>
